import '../scss/style.scss';
import appLoaded from './addons/appLoaded';
import { nodeListForEach } from './addons/polyfills';
import FormControler from './modules/form/FormControler';
import DropdownControler from './modules/dropdown/DropdownControler';
import TabControler from './modules/tab/TabControler';
import { initMapsInActiveTab } from './modules/map/googleMap';
import MasonryLayoutControler from './modules/masonryLayout/MasonryLayoutControler';
import ModalControler from './modules/modal/ModalControler';
import WorkHoursFilter from './modules/workHoursFilter';
import SliderControler from './modules/slider/SliderControler';
import HeaderControler from './modules/header/HeaderControler';
import MobileMenu from './modules/mobileMenu';
import PopupControler from './modules/popup/PopupControler';
import SearchControler from './modules/search/SerchControler';
import vhSetCustomUnit from './addons/vhUnitsCorrection';
import CircleControler from './modules/circles/CircleControler';

nodeListForEach();

const inits = (): void => {
  const formControler = new FormControler();
  const dropdownControler = new DropdownControler();
  const tabControler = new TabControler();
  initMapsInActiveTab();
  const masonryLayoutControler = new MasonryLayoutControler();
  const modalControler = new ModalControler();
  const workHoursFilter = new WorkHoursFilter();
  const sliderControler = new SliderControler();
  const headerControler = new HeaderControler();
  const mobileMenu = new MobileMenu();
  const popupControler = new PopupControler();
  const searchControler = new SearchControler();
  const circleControler = new CircleControler();
};

let thresholdPixels = 0;
let previosY = window.pageYOffset;

const scrollDown = (y: number) => y - previosY > 0;

const onScroll = (e: Event): void => {
  const y = window.pageYOffset;
  if (y > 0) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }

  if (y >= window.innerHeight * 0.3 && scrollDown(y)) {
    document.body.classList.add('hide-menu');
    thresholdPixels = 0;
  }

  if (!scrollDown(y)) {
    thresholdPixels += 1;
    if (thresholdPixels >= 20 || y < window.innerHeight * 0.3)
      document.body.classList.remove('hide-menu');
  }

  previosY = y;
};

const onResize = (e: Event): void => {
  onScroll(e);
  vhSetCustomUnit();
};

const onLoad = (e: Event): void => {
  inits();
  onResize(e);
  appLoaded();
};

window.addEventListener('load', onLoad);
window.addEventListener('resize', onResize);
window.addEventListener('scroll', onScroll);
